module.exports = __webpack_public_path__ + "img/logo_flexpay.da8359a2.png";